import { getErrorMessage } from '@/utils/errorUtils';

import { supabase } from '../client';
import { TeeBox } from '@/types';

/**
 * Gets or creates a tee box for a hole
 */
export const getOrCreateTeeBox = async (
  holeId: string,
  teeColor: TeeBox
) => {
  try {
    // Try to find existing tee box
    const { data: existingTeeBox, error: findError } = await supabase
      .from('tee_boxes')
      .select('id')
      .eq('hole_id', holeId)
      .eq('color', teeColor)
      .maybeSingle();
    
    if (findError) {
      console.error('Error finding tee box:', findError);
      return { error: findError.message };
    }
    
    // Return existing tee box if found
    if (existingTeeBox) {
      return { data: existingTeeBox.id };
    }
    
    // Create new tee box if not found
    const { data: newTeeBox, error: createError } = await supabase
      .from('tee_boxes')
      .insert({
        hole_id: holeId,
        color: teeColor,
        yardage: null // We don't have this info yet
      })
      .select()
      .single();
    
    if (createError) {
      console.error('Error creating tee box:', createError);
      return { error: createError.message };
    }
    
    return { data: newTeeBox.id };
  } catch (error) {
    console.error('Unexpected error in getOrCreateTeeBox:', error);
    return { error: getErrorMessage(error) };
  }
};
